import { initializeApp, getApp, getApps } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from "firebase/analytics";
import { getFunctions } from "firebase/functions";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

const firebaseConfig = {
  apiKey: "AIzaSyD_TKKoUQBIFhjXqSrrmO0DOSHU7EKVmpQ",
  authDomain: "narou-recommend-app.firebaseapp.com",
  projectId: "narou-recommend-app",
  storageBucket: "narou-recommend-app.appspot.com",
  messagingSenderId: "1086059466735",
  appId: "1:1086059466735:web:23321fc174eb955fc4b01a",
  measurementId: "G-VE6X50V6CJ"
};

// 重複初期化を防止する
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

export const auth = getAuth(app);
export const db = getFirestore(app);
export const analytics = getAnalytics(app);
export const functions = getFunctions(app, 'asia-northeast1');

export const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider("6LdFRWIrAAAAALY25AF5kxcxhDgmeU9TfWwE2fM3"),
  isTokenAutoRefreshEnabled: true
});